module.exports = {
  selectLanguage: "Seleccione su Idioma",
  "en-US": "English",
  es: "Español",
  glossary: "Glosario",
  topics: "Temas",
  about: "Acerca de",
  searchPlaceholder: "¿Qué preguntas tienes sobre inmigración?",
  featuredTopics: "Temas destacados",
  popularTerms: "Términos populares",
  disclaimer:
    "Este sitio web no debe reemplazar una consulta con un abogado/a. Alentamos a todas las personas involucradas con los sistemas de inmigración o justicia penal a consultar con un abogado/a.",
  allTopics: "Todos los temas",
  contactTitle: "¿Tiene comentario sobre este sitio web?",
  contactDisclaimer:
    "Necesitamos su dirección de correo electrónico para responder, pero no la compartiremos, ni la publicaremos. No podemos brindar asesoramiento legal sobre casos individuales, ni brindar representación legal.",
  contactName: "Nombre",
  contactEmail: "Dirección de correo electrónico",
  contactMessage: "Tu mensaje",
  contactSuccess:
    "¡Mensaje enviado! Alguien de Free Migration Project se pondrá en contacto con usted en breve.",
  contactError:
    'Vaya, parece que hay un problema con el sitio. Comuníquese con alguien en <a href="https://freemigrationproject.org/contact/">Free Migration Project</a>.',
  contactSubmit: "Enviar",
  relatedTerms: "Términos relacionados",
  viewGlossary: "Ver glosario",
  noSearchResults: "No se han encontrado resultados",
};
